<app-small-tuile
  type="icon"
  icon="fa-kit fa-picto-pacpoly"
  [title]="
    this.titles[actionStack!.getValue('ppPModeFonctionnementTemperature')]
      | translate
  "
  [content]="buttons[this.actionStack!.getValue('ppCModeFonctionnement')].icon!"
  [color]="buttons[this.actionStack!.getValue('ppCModeFonctionnement')].color!"
  [status]="
    buttonMode[this.actionStack!.getValue('ppSEtatFonctionnementPAC')].title!
      | translate
  "
  [mode]="
    this.actionStack!.getValue('ppPTemperatureConsigne') === 0
      ? ''
      : getTemperature(
          this.actionStack!.getValue('ppPTemperatureConsigne') / 10,
          0
        )
  "
  [statusMode]="
    buttonMode[this.actionStack!.getValue('ppSEtatFonctionnementPAC')].status!
  "
  (onPress)="this.openProductModal()"
>
</app-small-tuile>
